export default { sha: 'd952be29a1ab8e9b141670aec20e9f3ec38408f4', buildNumber: 'undefined' }
